import { render, staticRenderFns } from "./SupplierListRevise.vue?vue&type=template&id=80e5473e&"
import script from "./SupplierListRevise.vue?vue&type=script&lang=js&"
export * from "./SupplierListRevise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports